module.exports = __webpack_public_path__ + "static/img/cash.8a9a9ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/cash.png
// module id = aUH9
// module chunks = 215